<template>
  <div class="explore">
    <div class="d-none d-md-block mb-10">
      <link-cards />
    </div>
    <asset-list />
  </div>
</template>
<script>
import LinkCards from "./components/LinkCards";
import AssetList from "./components/AssetList";

export default {
  components: {
    LinkCards,
    AssetList,
  },
  methods: {
    loadData() {
      this.$store.dispatch("productStats/fetchVaultsStats");
      this.$store.dispatch("productStats/fetchStakeStats");
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
